// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message-modal{width:100%;border:1px solid #ccc}", "",{"version":3,"sources":["webpack://./app/pages/components/call-sheet/modal/index.scss"],"names":[],"mappings":"AAAA,eACE,UAAA,CACA,qBAAA","sourcesContent":[".message-modal {\n  width: 100%;\n  border: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
